export function handle3DSecure({
  onError,
  onVerified,
  response,
  verificationElement,
}) {
  let remove3DListeners;
  let promise = Promise.resolve();
  const requiresVerification = response?.data?.detail?.three_d_secure_action_token_id;
  if (requiresVerification) {
    // resolving 3DSecure is an async task. Since the listeners are not promise-friendly,
    // but we want to await the result, we wrap the call with a promise that's
    // resolved at a right time.
    promise = new Promise(
      (resolve) => {
        const risk = recurly.Risk();
        const threeDSecure = risk.ThreeDSecure({
          actionTokenId: response.data.detail.three_d_secure_action_token_id,
        });

        remove3DListeners = function innerRemove3DListeners() {
          threeDSecure.off('token', innerOnVerified); // eslint-disable-line no-use-before-define
          threeDSecure.off('error', innerOnError); // eslint-disable-line no-use-before-define
        };

        async function innerOnVerified(verifiedToken) { // eslint-disable-line no-inner-declarations
          // After completing 3DS challenge, initiate another purchase with the new token
          await onVerified({ threeDsToken: verifiedToken });
          remove3DListeners();
          threeDSecure.remove();
          resolve();
        }

        function innerOnError(error) { // eslint-disable-line no-inner-declarations
          // If 3DS verification fails, show error message
          onError(error);
          remove3DListeners();
          threeDSecure.remove();
          resolve();
        }

        threeDSecure.on('token', innerOnVerified);
        threeDSecure.on('error', innerOnError);
        threeDSecure.attach(verificationElement);
      },
    );
  }

  return { remove3DListeners, promise, response };
}

export default handle3DSecure;
